import { render, staticRenderFns } from "./header.vue?vue&type=template&id=f235d5e0&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=f235d5e0&prod&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=f235d5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f235d5e0",
  null
  
)

export default component.exports